export default function register() {
  if (navigator.serviceWorker) {
    navigator.serviceWorker.register('/sw.js');
  }
}